export default __webpack_public_path__ + "static/media/logo.d0ce6f2a.png";